var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Layer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #83b797 } \n\t\t.s1 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m20 40c11 0 20-9 20-20 0-11-9-20-20-20-11 0-20 9-20 20 0 11 9 20 20 20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m24.5 16.6h-3.1v-2q0-0.2 0.1-0.4 0-0.2 0.1-0.3 0.2-0.1 0.3-0.2 0.2-0.1 0.4-0.1h2.2v-3.3h-3q-0.9-0.1-1.6 0.2-0.8 0.3-1.4 0.9-0.6 0.6-0.9 1.3-0.3 0.8-0.2 1.7v2.2h-1.9v3.4h1.9v9.7h4v-9.7h2.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook1);
export default __webpack_public_path__ + "static/media/facebook1.9aa2618e5df176389ef946450d87eb2b.svg";
export { ForwardRef as ReactComponent };